// 吉兰丹州球场数据
// Kelantan Golf Courses

export const KELANTAN_COURSES = {
  "KELAB_GOLF_GUA_MUSANG": {
    shortName: "KGGM",
    fullName: "Kelab Golf Gua Musang",
    location: ["Gua Musang", "Kelantan", "Malaysia"],
    pars: [0,0,0,0,0,0,0,0,0],
    index: [,,,,,,,,]
  },

  "KELAB_REKREASI_TENTERA_DARAT_DESA_PAHLAWAN": {
    shortName: "KRTDDP",
    fullName: "Kelab Rekreasi Tentera Darat Desa Pahlawan",
    location: ["Kota Bharu", "Kelantan", "Malaysia"],
    pars: [0,0,0,0,0,0,0,0,0],
    index: [,,,,,,,,]
  },

  "KELANTAN_GOLF_AND_COUNTRY_CLUB": {
    shortName: "KGCC",
    fullName: "Kelantan Golf and Country Club",
    location: ["Kota Bharu", "Kelantan", "Malaysia"],
    pars: [4,3,5,4,4,3,5,4,4, 4,5,3,4,5,4,4,3,4],
    index: [9,15,11,5,3,17,1,13,7, 8,12,14,2,10,18,4,16,6]
  }
};

export default KELANTAN_COURSES;
